export default __webpack_public_path__ + "static/media/img-0258-afghanistan-premium-face.af10e9be.png";